module.exports = __webpack_public_path__ + "img/img_04 - 副本.575a22db.png";